import { FilterPanel, SecondaryFilterProps } from "@mcleod/dispatch";
import { AutogenLayoutCarrierActionList } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierActionList";
import { ModelRow, SortDirection, SortUtil, StringUtil } from "@mcleod/core";
import { ModelCarrier, RowCarrier } from "@mcleod/dispatch/src/models/ModelCarrier"; // Adjust the module path as needed
import { ClickEvent, DataSourceMode, LookupModelSelectionEvent, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { CarrierAction } from "./CarrierAction";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";

export class CarrierActionList extends AutogenLayoutCarrierActionList {
    private _carrierId: string;

    private actionFilterPanel: FilterPanel;
    private actionSecondaryFilters: SecondaryFilterProps[] = [{
        id: "upcomingActions",
        caption: "Upcoming",
        filter: (row: ModelRow) => row.isNull('action_date')
    },{
        id: "completedActions",
        caption: "Completed",
        filter: (row: ModelRow) => !row.isNull('action_date')
    }];

    onLoad(): void | Promise<void> {        
        this.tableActivities.onEditLayoutLoaded = (decorator, tableRow) => decorator.multiButton.dropdownItems = null;
    }

    buttonAddActionOnClick(event: ClickEvent) {
        CarrierAction.showAddActionSlideout(null, {
            doAfterSlideIn: (slideout) => {
                const layout = slideout.layout as CarrierAction;
                layout.textboxCarrierId.enabled = false;
                new ModelCarrier().searchSingle({ "id": this.carrierId}, "lme/dispatch/Carrier")
                .then((carrier: RowCarrier) => {
                    layout.activeRow.setValueAndLookupModelData("carrier_id", this.carrierId, {name: carrier.getString("payee.name")});
                    layout.textboxCarrierIdOnLookupModelSelection(new LookupModelSelectionEvent(layout.textboxCarrierId, carrier));
                });
            },
            onSave: (updatedData) => updatedData.post().then(() => this.mainDataSource.search({ carrier_id: this.carrierId }))
        });
    }

    tableActivitiesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data as ModelRow;
        const status = modelRow.getString("status", null);
        tableRow.allowDelete = "C" !== status;
        tableRow.forEveryChildComponent((child) => {
            if (child instanceof Textbox) {
                child.printable = this.sourceCarrierAction.mode !== DataSourceMode.SEARCH;
            }
        });
        this.setupActionFilterPanel();
    }

    private setupActionFilterPanel() {
        if (this.sourceCarrierAction.mode !== DataSourceMode.SEARCH) {
            this.actionFilterPanel = new FilterPanel(this.actionSecondaryFilters, this.tableActivities, this.panelSecondaryFilters);
        }
    }
    
    tableRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data as ModelRow;
        const activityId = modelRow.getString("activity_id");
        const dateDue = modelRow.getDate("date_due");
        let props: Partial<EditRowDecoratorProps> = {
            onSave: (updatedData) => updatedData.post().then(() => this.mainDataSource.search({ carrier_id: this.carrierId }))
        };
        if ("C" !== modelRow.getString("status", null)) {
            props = {
                ...props,
                onDelete: () => this.mainDataSource.search({ carrier_id: this.carrierId })
            }
        }

        CarrierAction.showEditActionSlideout(modelRow, props);
    }

    findNextActivity(activityId: string, dateDue: Date): {id: string, descr: string, date_due: Date} {
        const carrierActivities = this.mainDataSource.data.filter((row: ModelRow) => row.isNull('action_date'))
            .sort((a:ModelRow, b:ModelRow) => {
                const sortInfo:{fieldName: string, sort: SortDirection}[] = [
                    {fieldName: "date_due", sort: "asc"},
                    {fieldName: "priority", sort: "desc"}
                ]
                for (const fieldSortInfo of sortInfo) {
                    const valueA = SortUtil.getSortTestValue(a, fieldSortInfo.fieldName);
                    const valueB = SortUtil.getSortTestValue(b, fieldSortInfo.fieldName);
                    const compareResult = SortUtil.compareTwoValues(valueA, valueB, fieldSortInfo.sort, false);
                    if (compareResult !== 0)
                        return compareResult;
                }
                return 0;
            });
        let nextActivity = null;
        if (!activityId && !dateDue) {
            nextActivity = carrierActivities[0];
        } else {
            let i = 0;
            let rowMatch = false;
            while(!rowMatch && i < carrierActivities.length) {
                const activityRow = carrierActivities[i++];
                if (activityId === activityRow.getString("activity_id")
                && dateDue.getTime() === activityRow.getDate("date_due").getTime()) {
                    rowMatch = true;
                }
            }
            nextActivity = carrierActivities[i];
        }
        return {
            id: nextActivity?.getString("activity_id"),
            descr: nextActivity?.getString("descr"),
            date_due: nextActivity?.getDate("date_due")
        };
    }

    public get carrierId(): string {
        return this._carrierId;
    }
    public set carrierId(value: string) {
        this._carrierId = value;
        this.buttonAddAction.visible = !StringUtil.isEmptyString(value);
    }

}
